export const state = () => ({
  sections: {},
})

export const mutations = {
  addSections(state, sections) {
    state.sections = sections
  },
}
